import React from 'react'

import { NavLink } from 'react-router-dom'

import colorsJson from '../../colors.json'

interface BigMenuLinkProps {
  to: string
  className?: string
  children: React.ReactNode
  exact?: boolean
  props?: never
}

export const BigMenuLink = ({
  className,
  children,
  to,
  ...props
}: BigMenuLinkProps) => {
  return (
    <NavLink
      tabIndex={0}
      activeStyle={{ color: colorsJson['colors']['Brand/PrimaryGreen'] }}
      to={to}
      className={className}
      exact
      {...props}
    >
      {children}
    </NavLink>
  )
}

export default BigMenuLink
